let elements = [
  //////////////
  // 1
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page007_game1/audio/false.mp3',
      // positive: 'games/page007_game1/audio/true.mp3',
      click: 'games/page007_game1/audio/click.mp3',
    },
    image: {
      trImage: 'games/page007_game1/img/img_t.webp',
      srcImage: 'games/page007_game1/img/img_o.png',
      srcMask: 'games/page007_game1/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#e62f26',
        3: '#ffff00',
        4: '#05a6e2',
        5: '#4faf48',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          val: '#05a6e2', // blue
          audio: 'games/page007_game1/audio/10_blue.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/blue.png' },
          clicked: { src: 'games/page007_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '30%',
            top: '73.4%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#e62f26', // red
          audio: 'games/page007_game1/audio/8_red.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/red.png' },
          clicked: { src: 'games/page007_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '25.8%',
            top: '67.6%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#ffff00', // yellow
          audio: 'games/page007_game1/audio/9_yellow.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/yellow.png' },
          clicked: { src: 'games/page007_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '24.8%',
            top: '77.5%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#4faf48', // green
          audio: 'games/page007_game1/audio/11_green.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/green.png' },
          clicked: { src: 'games/page007_game1/img/green_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '19.9%',
            top: '73.4%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
      ],
    },
    mbStaticAudioItemData: [
      {
        src: 'games/page007_game1/audio/8_red.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 386,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/9_yellow.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 793,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/10_blue.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 1200,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/11_green.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 1607,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
    ],
  },
  //////////////
  // 2
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page007_game1/audio/false.mp3',
      // positive: 'games/page007_game1/audio/true.mp3',
      click: 'games/page007_game1/audio/click.mp3',
    },
    image: {
      trImage: 'games/page007_game1/img/img_t.webp',
      srcImage: 'games/page007_game1/img/img_o.png',
      srcMask: 'games/page007_game1/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#ffff00',
        3: '#05a6e2',
        4: '#4faf48',
        5: '#e62f26',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          val: '#05a6e2', // blue
          audio: 'games/page007_game1/audio/10_blue.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/blue.png' },
          clicked: { src: 'games/page007_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '30%',
            top: '73.4%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#e62f26', // red
          audio: 'games/page007_game1/audio/8_red.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/red.png' },
          clicked: { src: 'games/page007_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '25.8%',
            top: '67.6%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#ffff00', // yellow
          audio: 'games/page007_game1/audio/9_yellow.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/yellow.png' },
          clicked: { src: 'games/page007_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '24.8%',
            top: '77.5%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#4faf48', // green
          audio: 'games/page007_game1/audio/11_green.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/green.png' },
          clicked: { src: 'games/page007_game1/img/green_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '19.9%',
            top: '73.4%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
      ],
    },
    mbStaticAudioItemData: [
      {
        src: 'games/page007_game1/audio/9_yellow.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 386,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/10_blue.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 793,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/11_green.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 1200,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/8_red.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 1607,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
    ],
  },
  //////////////
  // 3
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page007_game1/audio/false.mp3',
      // positive: 'games/page007_game1/audio/true.mp3',
      click: 'games/page007_game1/audio/click.mp3',
    },
    image: {
      trImage: 'games/page007_game1/img/img_t.webp',
      srcImage: 'games/page007_game1/img/img_o.png',
      srcMask: 'games/page007_game1/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#05a6e2',
        3: '#e62f26',
        4: '#ffff00',
        5: '#4faf48',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          val: '#05a6e2', // blue
          audio: 'games/page007_game1/audio/10_blue.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/blue.png' },
          clicked: { src: 'games/page007_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '30%',
            top: '73.4%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#e62f26', // red
          audio: 'games/page007_game1/audio/8_red.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/red.png' },
          clicked: { src: 'games/page007_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '25.8%',
            top: '67.6%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#ffff00', // yellow
          audio: 'games/page007_game1/audio/9_yellow.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/yellow.png' },
          clicked: { src: 'games/page007_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '24.8%',
            top: '77.5%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#4faf48', // green
          audio: 'games/page007_game1/audio/11_green.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/green.png' },
          clicked: { src: 'games/page007_game1/img/green_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '19.9%',
            top: '73.4%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
      ],
    },
    mbStaticAudioItemData: [
      {
        src: 'games/page007_game1/audio/10_blue.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 386,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/8_red.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 793,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/9_yellow.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 1200,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/11_green.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 1607,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
    ],
  },
  //////////////
  // 4
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page007_game1/audio/false.mp3',
      // positive: 'games/page007_game1/audio/true.mp3',
      click: 'games/page007_game1/audio/click.mp3',
    },
    image: {
      trImage: 'games/page007_game1/img/img_t.webp',
      srcImage: 'games/page007_game1/img/img_o.png',
      srcMask: 'games/page007_game1/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#4faf48',
        3: '#ffff00',
        4: '#e62f26',
        5: '#05a6e2',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          val: '#05a6e2', // blue
          audio: 'games/page007_game1/audio/10_blue.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/blue.png' },
          clicked: { src: 'games/page007_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '30%',
            top: '73.4%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#e62f26', // red
          audio: 'games/page007_game1/audio/8_red.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/red.png' },
          clicked: { src: 'games/page007_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '25.8%',
            top: '67.6%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#ffff00', // yellow
          audio: 'games/page007_game1/audio/9_yellow.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/yellow.png' },
          clicked: { src: 'games/page007_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '24.8%',
            top: '77.5%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
        {
          val: '#4faf48', // green
          audio: 'games/page007_game1/audio/11_green.mp3',
          waitingToBeClicked: { src: 'games/page007_game1/img/green.png' },
          clicked: { src: 'games/page007_game1/img/green_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '19.9%',
            top: '73.4%',
            width: '5%',
            height: '9.3%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(83,187,63,0.4)',
          },
        },
      ],
    },
    mbStaticAudioItemData: [
      {
        src: 'games/page007_game1/audio/11_green.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 386,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/9_yellow.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 793,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/8_red.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 1200,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
      {
        src: 'games/page007_game1/audio/10_blue.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page007_game1/img/audioOn.png', iconOff: 'games/page007_game1/img/audioOff.png' },
          fill: 'black',
        },
        pos: {
          y: 455,
          x: 1607,
        },
        width: '46px',
        height: '46px',
        unit: 'px',
      },
    ],
  },
];

export default { ...elements, blockCheck: true };
